import React, { useEffect, useState } from 'react'
import { HTTP } from '../../../../api/resources'

export default function PageSponsorshipAmount(props) {
    const [sponsorships, setSponsorships] = useState(props.sponsorships ? props.sponsorships : [])
    const [allSponsorships, setAllSponsorships] = useState(props.allSponsorships)
    const [newSponsorship, setNewSponsorship] = useState()
    const page = props.page
    const user = props.user

    const removeSponsorship = async (sponsorship) => {
        try {
            let response = await deleteRequest(sponsorship)
            setSponsorships(response.data)
            Alert.show('notice', 'Sponsorship amount deleted')
        } catch {
            Alert.show('error', 'Error deleting sponsorship amount')
            return
        }
    }

    const handleAddSponsorship = async () => {
        try {
            let response = await postRequest()
            setSponsorships(response.data)
            setNewSponsorship()
            Alert.show('notice', 'Sponsorship amount added')
        } catch {
            Alert.show('error', 'Error adding sponsorship amount')
            return
        }
    }

    const handleFetchAmounts = async () => {
        try {
            let response = await fetchAmounts()
            props.close(response.data)
        } catch {
            Alert.show('notice', 'Unable to update page dynamically, reloading....')
            window.location.reload()
        }
    }

    // requests 
    const postRequest = () => {
        return HTTP.post(`/sponsorship/amount/create/${page.id}/${user.id}/${newSponsorship}`)
    }

    const deleteRequest = (sponsorship) => {
        return HTTP.delete(`/sponsorship/amount/delete/${page.id}/${user.id}/${sponsorship.id}`)
    }

    const fetchAmounts = () => {
        return HTTP.get(`/sponsorship/amount/fetch/${page.id}/${user.id}`)
    }
  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <h4>Sponsorship Amounts</h4>
                <div>
                    {sponsorships && sponsorships.map(sponsorship => (
                        <div key={sponsorship.id} className='d-flex justify-content-between align-items-center mb-2'>
                            <p>{sponsorship.amount}</p>
                            <button onClick={() => removeSponsorship(sponsorship)} type='button' className='btn btn-icon btn-outline-danger' >
                                <i className='fa fa-trash'></i>
                            </button>
                        </div>
                    ))}
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label htmlFor='new_option'>Add Sponsorship</label>
                            <input type='number' step="1" className='form-control' name='new_option' id='new_option' placeholder='100' 
                                value={newSponsorship} onChange={(event) => setNewSponsorship(event.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="pt-3">
                    <button onClick={() => handleAddSponsorship()} type="button" className="btn btn-primary mr-2" disabled={!newSponsorship}>
                        Add Sponsorship
                    </button>

                    <button onClick={handleFetchAmounts} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>

            </div>
        </div>
    </div>
  )
}
